<section class="tw-flex tw-flex-col tw-items-center tw-justify-center">
  <div
    class="tw-flex tw-size-16 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border-2 tw-border-solid tw-border-slate-200 tw-bg-slate-50">
    <ate-icon class="tw-size-8 tw-text-slate-800" name="notification-bell-active-v3"></ate-icon>
  </div>
  <h2 class="tw-mt-5 tw-text-center tw-text-xl tw-text-slate-800">
    Would you like to be notified when you receive new invitations and other important events?
  </h2>
  <p class="tw-mb-0 tw-mt-3 tw-text-center tw-text-sm tw-text-slate-600">
    Choosing 'Yes, turn on notifications' will open a browser permissions message where you can opt-in to receive browser notifications.
  </p>
</section>
